// extracted by mini-css-extract-plugin
module.exports = {"Switch":"ToggleSwitch_Switch__1hy7m","active":"ToggleSwitch_active__1ODPQ","ToggleSwitch":"ToggleSwitch_ToggleSwitch__Lxyud"};